import { productImageStyles } from "@insite/content-library/Components/ProductImage";
import { productListStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductList";
import { productListLineStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsProductListLine";
import { css } from "styled-components";

productListStyles.container = {
    gap: 0,
    css: css`
        /* Note: below line is to prevent a weird behavior where chrome wants to print anything that will fit
            * comprehensively on a single page on that page, which means the product list appears on page 2
            when rendering a common 8-item list with no notes. That's not ideal, so we're arbitrarily making
            the component large enough that it won't fit on a single page. */
        @media print {
            padding-bottom: 120px;
        }
        border-top: 1px lightgray solid;
        [color^="success"] {
            background: transparent;
            span[class^="IconWrapper"] {
                background: #008061;
                border-radius: 50%;
                padding: 2px;
                height: 16px;
                width: 16px;
                svg {
                    height: 12px;
                    width: 12px;
                    color: #fff;
                }
            }
        }
        [color^="danger"] {
            background: transparent;
            span[class^="IconWrapper"] {
                background: #008061;
                border-radius: 50%;
                padding: 2px;
                height: 16px;
                width: 16px;
                svg {
                    height: 12px;
                    width: 12px;
                    color: #fff;
                }
            }
        }
    `,
};

productListLineStyles.imageWrapper = {
    css: css`
        @media print {
            max-height: 83px;
            max-width: 83px;
        }
        width: 100%;
        min-width: 0;
        flex-direction: column;
        [data-test-selector="productImage"] {
            height: 150px;
            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
                object-position: center top;
            }
        }
    `,
}